import { NO_PREMIUM_OPTIONS } from '@griply/hooks';
import { LimitKeys } from '@griply/types';
import { usePremiumFeatureAllowed } from 'shared/hooks/use-premium-feature-allowed';

// Parallel to mobile's copy: each app's usePremiumFeatureAllowed reads its own contexts.
export const useCreateCalendarEventAllowed = () =>
  usePremiumFeatureAllowed(LimitKeys.CreateCalendarEvent, NO_PREMIUM_OPTIONS);
